exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-race{display:flex;align-items:stretch;flex-wrap:wrap}.select-race label{font-weight:400;flex:1 1 31%;display:relative}@media only screen and (max-width:767px){.select-race label{flex:1 1 48%}}.select-race label>div{top:100%;transform:translateY(-100%);position:relative;text-align:center;font-weight:700;text-transform:capitalize}.select-race__select-ability{display:flex;align-items:stretch;flex-wrap:wrap}.select-race__select-ability label{font-weight:400;flex:1 1 31%;display:relative}.select-race__select-ability label>div{top:100%;transform:translateY(-100%);position:relative;text-align:center;font-weight:700;text-transform:capitalize}.select-race__image{margin-bottom:1rem;width:92px;height:auto}.ability-bonuses>span{text-transform:capitalize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c23e558","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SelectRace.vue
// module id = 52
// module chunks = 0